import { render, staticRenderFns } from "./AssistantChat.vue?vue&type=template&id=1f851725&scoped=true"
import script from "./AssistantChat.vue?vue&type=script&lang=js"
export * from "./AssistantChat.vue?vue&type=script&lang=js"
import style0 from "./AssistantChat.vue?vue&type=style&index=0&id=1f851725&prod&scoped=true&lang=css"
import style1 from "./AssistantChat.vue?vue&type=style&index=1&id=1f851725&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f851725",
  null
  
)

export default component.exports